import React from 'react'
import { MenuItem, SplitButton, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import Radium from 'radium'
import propTypeSchema from 'react-json-schema-proptypes'
import { Project, Typography } from '../types'

const schema = {
  'type': 'object',
  'properties': {
  }
}

@Radium
export default class ProjectSelector extends React.PureComponent {
  static propSchema = schema
  static propTypes = propTypeSchema(schema, {
    'required': ['onChange', 'projects', 'onChangeMetadata'],
    'properties': {
      'projects': {'type': 'array', 'items': Project.Schema},
      'selectedProject': Project.Schema,
      'currentMetadata': {'type': 'object'},
      'onChange': {'isFunction': true},
      'onChangeMetadata': {'isFunction': true},
      'hasError': {'type': 'boolean'},
      'extraMetadataHasError': {'type': 'boolean'},
      'displayErrors': {'type': 'boolean'},
      'projectQuestionValue': {'type': 'string'},
      'astStyle': Typography.Schema
    }
  })
  static defaultProps = {
    questionHasError: false
  }

  constructor (props) {
    super(props)
    this.state = {
      dropdownItems: [],
      dropdownHasError: false,
      metadataHasError: false
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.projects !== prevProps.projects) {
      this.getDropdownItems()
    }
  }

  componentDidMount () {
    this.getDropdownItems()
    if (this.props.selectedProject && this.props.selectedProject.hasQuestion) {
      this.setState({
        metadataHasError: true
      }, () => {
        this.props.onChangeMetadata(this.props.selectedProject.questionLabel, '', this.state.metadataHasError)
      })
    }
    if (this.props.selectedProject && typeof this.props.selectedProject.id === 'undefined') {
      this.setState({
        projectHasError: true
      }, () => {
        this.props.onChange(this.props.selectedProject, this.state.projectHasError)
      })
    }
  }

  changeSelectedProject = (projectId) => {
    const theProject = this.props.projects.filter(project => project.id === projectId)[0]
    this.setState({
      projectHasError: typeof theProject.id === 'undefined',
      metadataHasError: !!theProject.hasQuestion
    }, () => {
      this.props.onChange(theProject, this.state.projectHasError)
    })
  }

  changeMetadata = (e) => {
    this.props.onChangeMetadata(this.props.selectedProject.questionLabel, e.target.value, e.target.value.length === 0)
    this.setState({
      metadataHasError: e.target.value.length === 0
    })
  }

  getDropdownItems () {
    let dropdownItems = []
    for (let project in this.props.projects) {
      dropdownItems.push(
        <MenuItem
          eventKey={project.id}
          active={this.props.selectedProject.id === project.id}
          onSelect={this.changeSelectedProject.bind(this)}>
          {project.name}
        </MenuItem>
      )
    }
    this.setState({
      dropdownItems: dropdownItems
    })
  }

  render () {
    return <div className='projectSelector'>
      <div className={(this.state.projectHasError && this.props.displayErrors ? 'dropdown-error ' : '') + 'dropdown-style'}>
        <SplitButton bsSize='large' title={this.props.selectedProject.name} id={'Projects'}
        >
          {this.props.projects.map(project =>  <MenuItem
            eventKey={project.id}
            key={project.id}
            active={this.props.selectedProject.id === project.id}
            onSelect={this.changeSelectedProject}>
            {project.name}
          </MenuItem>)}
        </SplitButton>
      </div>
      {this.props.selectedProject.hasQuestion &&
      <div>
        <FormGroup
          className={'infoEntry dropDownQuestionEntry' + (this.state.metadataHasError && this.props.displayErrors ? ' has-error' : '')}
          controlId='projectQuestion'>
          <ControlLabel>
            {this.props.selectedProject.questionLabel ? this.props.selectedProject.questionLabel : ''}
            {this.props.selectedProject.questionLabel && <span style={this.props.astStyle}> *</span>}
          </ControlLabel>
          {this.props.questionHasError &&
          <div className='formError'>&nbsp;Answer Required</div>
          }
          <FormControl
            name='projectQuestion'
            id='projectQuestion'
            type='text'
            value={this.props.currentMetadata[this.props.selectedProject.questionLabel]}
            onChange={this.changeMetadata} />
        </FormGroup>
      </div>
      }
    </div>
  }
}

